import React from 'react';
import { loaderSvg } from '../theme/loaderSvg';

function Loader(props) {
  return <div className="loader">{loaderSvg()}</div>;
}

export default Loader;
